module.exports = __webpack_public_path__ + "static/media/the-game-cricket-2024-early-bird.8ce8c9dd.png";